<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <h2>Select how you would like to create your ad</h2>
    </v-col>
    <v-col cols="12">
      <v-row>
        <message-selector-element
          v-for="(path, index) in creativePaths"
          :key="index"
          :path="path"
          @selectCreativePath="selectCreativePath"
          v-if="!path.feature || features[path.feature]"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import MessageSelectorElement from './MessageSelectorElement.vue'
export default {
    name: 'message-selector',
    components: { MessageSelectorElement },
    data () {
      return {
        creativePaths: [
          {
            icon: 'add_a_photo',
            title: 'Upload or select an image',
            value: 'create-ad'
          },
          {
            icon: 'movie',
            title: 'Upload or select a video',
            value: 'video-ad'
          },
          {
            icon: 'book',
            title: 'Promote a Facebook post',
            value: 'promote-post'
          },
          {
            icon: 'collections',
            title: 'Use an Outfox creative template',
            value: 'use-template',
            feature: 'creative_templates'
          },
          {
            icon: 'color_lens',
            title: 'Get creative help',
            value: 'get-help'
          }
        ]
      }
    },
    methods: {
      closeDialog () {
        this.$emit('closeDialog')
      },
      selectCreativePath (path) {
        this.$emit('selectCreativePath', path)
      }
    },
    computed: {
      features () {
        const version = this.$store.getters.getAppVersion
        return this.$store.getters.getFeatures[version]
      }
    }
  }
</script>
